var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('OptionList', {
    attrs: {
      "items": _vm.items,
      "perRow": _vm.perRow
    },
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }